import { selectClasses, SxProps } from '@mui/material'
import { filterDropdownClasses } from '../FilterDropdown.data'

export const filterDropdownIconStyles: Record<string, SxProps> = {
  [`.${filterDropdownClasses.dropdownIcon}`]: {
    color: 'text.quaternary500',
    width: '12px',
    height: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'color 0.2s ease',
    cursor: 'pointer',
    marginRight: '3px',
    svg: {
      width: '12px',
      height: '12px',
    },
    [`&.${filterDropdownClasses.dropdownCrossIcon}`]: {
      color: 'utils.blue300',
    },
  },
  [`&.active .${filterDropdownClasses.dropdownIcon}`]: {
    color: 'utils.blue300',
  },
  [`&:hover .${filterDropdownClasses.dropdownIcon}`]: {
    color: 'text.secondary700',
  },
  [`&:hover .${filterDropdownClasses.dropdownIcon}.${filterDropdownClasses.disabled}`]: {
    color: 'action.disabled',
  },

  [`&.${selectClasses.focused} .${filterDropdownClasses.dropdownIcon}`]: {
    color: 'utils.blue300',
  },
  [`&:hover .${filterDropdownClasses.dropdownCrossIcon}`]: {
    color: 'utils.blue300',
  },

  [`.${filterDropdownClasses.disabled}`]: {
    color: 'action.disabled',
    cursor: 'not-allowed',
  },
}
